
import { CompactUser } from "../../../../core/CompactModels";
import ApexChart from "../../../../models/ApexChart";
import Job from "../../../crm/jobs/models/Job";
import JobsPieChartModel from "./JobsPieChartModel";

export default interface JobReportModel {
    pieChart?: JobsPieChartModel
    callsToJobRate: number
    jobsToClosedRate: number
    chart?: ApexChart
    jobs?: Job[]
    data?: JobReportDataRow[]
    techPayments?: JobReportTechPaymentRow[]
    cancelReasons?: JobCancelReasonShare[]
}

export interface JobCancelReasonShare {
    key: string
    name?: string
    count: number
    percent: number
    isReason?: boolean
    isOther?: boolean
    jobIds: string[]
    items?: JobCancelReasonShare[]
}

export interface JobReportDataRow {
    id?: string
    name?: string
    type?: string
    state?: string
    avatar?: string
    totalJobs: number
    totalCalls: number
    conversionRate: number
    averageTickets?: number
    totalGross?: number
    totalProfit?: number
    sourceProfit?: number
    sourceBalance?: number
    statusCounts: JobReportDataRowStatusCount[]
}

export interface JobReportDataRowStatusCount {
    id?: string
    name?: string
    color?: string
    jobsCount?: number
    percent?: number
    isClosedStatus: boolean
    isCanceledStatus: boolean
}

export interface JobReportTechPaymentRow {
    tech?: CompactUser
    lastReportSent?: Date
    metros?: string
    types?: string
    sources?: string
    closedJobs?: number
    total?: number
    cash?: number
    cccharge?: number
    ccmanual?: number
    check?: number
    epay?: number
    rinvoxPay?: number
    balance?: number
    isTotalRow?: boolean
}

export interface JobsColumnsVisibility {
    client?: boolean
    job?: boolean
    name?: boolean
    phone?: boolean
    status?: boolean
    type?: boolean
    source?: boolean
    metro?: boolean
    address?: boolean
    createdDate?: boolean
    lastUpdate?: boolean
    apptDate?: boolean
    agent?: boolean
    tech?: boolean
    cancelNote?: boolean
    invNo?: boolean
    total?: boolean
    cash?: boolean
    ccmanual?: boolean
    cccharge?: boolean
    check?: boolean
    epay?: boolean
    rinvoxPay?: boolean
    coParts?: boolean
    techParts?: boolean
    techFee?: boolean
    sourceFee?: boolean
    totalFee?: boolean
    tax?: boolean
    coProfits?: boolean
    techProfits?: boolean
    sourceProfits?: boolean
    techBalance?: boolean
}

// Column visibility -> export query string, the one encoding the HUB's JobReportExportOptions
// binds from. Booleans become True/False; a list (the toggled status columns) is repeated
// per value, `statuses=id1&statuses=id2`, which is how ASP.NET fills a List<string>. The
// old `${key}=${value ? "True" : "False"}` turned the list into `statuses=True`, so the PDF
// and CSV never got the status columns the table was showing.
export const visibilityToQuery = (vis: object): string =>
    Object.entries(vis)
        .filter(([, value]) => value !== undefined && value !== null)
        .flatMap(([key, value]) =>
            Array.isArray(value)
                ? value.map(v => `${key}=${encodeURIComponent(String(v))}`)
                : [`${key}=${value ? "True" : "False"}`])
        .join("&")

export interface DataColumnsVisibility {
    jobs?: boolean
    convrate?: boolean
    avgtick?: boolean
    gross?: boolean
    sourceprofit?: boolean
    profit?: boolean
    statuses?: string[]
}

export interface TechPayColumnsVisibility {
    phone?: boolean
    metro?: boolean
    source?: boolean
    type?: boolean
    closedJobs?: boolean
    total?: boolean
    totalCash?: boolean
    cash?: boolean
    ccmanual?: boolean
    cccharge?: boolean
    check?: boolean
    epay?: boolean
    rinvoxPay?: boolean
    techBalance?: boolean
}